import { render, staticRenderFns } from "./TotalQuotation.vue?vue&type=template&id=1f6ce480&"
import script from "./TotalQuotation.vue?vue&type=script&lang=ts&"
export * from "./TotalQuotation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports